import React from 'react'
import _get from 'lodash/get'
import { get as getConfig } from 'config'
import PlaylistAddRemoveGraphql from './PlaylistAddRemoveGraphql'
import PlaylistAddRemoveRest from './PlaylistAddRemoveRest'

const config = getConfig()
const myLibraryGQLEnabled = !!_get(config, ['features', 'myLibraryPageGraphQL'])

function PlaylistAddRemove (props) {
  return myLibraryGQLEnabled
    ? <PlaylistAddRemoveGraphql {...props} />
    : <PlaylistAddRemoveRest {...props} />
}

export default PlaylistAddRemove
